// MF async boundary — 공유 스코프 초기화를 보장한 뒤 실제 진입.
// 이 lazy entry 덕분에 shared에 eager:true가 필요 없다(공식 권장 조합).
import('./bootstrap');
